export default function() {
  return this._root;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-quadtree/src/root.js
// module id = ../../../../d3-quadtree/src/root.js
// module chunks = vendor